import type { FunctionCategory, SessionStats } from '@tunasong/music-lib'
import { Button } from '@tunasong/ui-lib'
import type { FC } from 'react'
import { useTheoryCopy } from '../theory-copy/use-theory-copy.js'
import styles from './function-quiz-summary.module.css'

const CATEGORY_LABELS: Record<FunctionCategory, string> = {
  tonic: 'Tonic',
  predominant: 'Predominant',
  dominant: 'Dominant',
}

const CATEGORY_ORDER: FunctionCategory[] = ['tonic', 'predominant', 'dominant']

export interface FunctionQuizSummaryProps {
  stats: SessionStats
  onRestart: () => void
}

/**
 * Function Quiz v1 end-of-session summary. Shows total score, per-category
 * breakdown (counted under each question's PRIMARY category — see
 * computeSessionStats), and a lexicon-driven Bowie footer reinforcing the
 * core idea of function-as-context.
 */
export const FunctionQuizSummary: FC<FunctionQuizSummaryProps> = props => {
  const { stats, onRestart } = props
  const footer = useTheoryCopy('function-quiz-feedback')
  return (
    <section className={styles.summary} aria-label="Session complete">
      <h2 className={styles.title}>Session complete</h2>
      <p className={styles.score}>
        {stats.correct} / {stats.total}
      </p>
      <dl className={styles.breakdown}>
        {CATEGORY_ORDER.map(cat => (
          <div key={cat} className={styles.row}>
            <dt className={styles.rowLabel}>{CATEGORY_LABELS[cat]}</dt>
            <dd className={styles.rowValue}>
              {stats.byCategory[cat].correct} / {stats.byCategory[cat].total}
            </dd>
          </div>
        ))}
      </dl>
      {footer ? <p className={styles.footer}>{footer.body}</p> : null}
      <Button variant="contained" color="primary" size="large" onClick={onRestart}>
        Start new session
      </Button>
    </section>
  )
}
